import { getEnumMap, isEmpty, isEmptyOrWhiteSpace } from "@/utils/Common";
import store from "@/stores/index";

let payType: Map<string, any> | null = null;
let userLevel: Map<string, any> | null = null;
let messageType: Map<string, any> | null = null;

let gender: Map<string, any> | null = null;
let operationType: Map<string, any> | null = null;


const map: any = {
  formatAmount(data: any, column: any, value: any) {
    if (isEmptyOrWhiteSpace(value)) {
      return value;
    }
    const amount = value;
    if (data.revenueCategoryId > 0) {
      return `收入-${data.revenueCategory.name} <font color=green>(+${amount})</font>`;
    } else if (data.expenseCategoryId > 0) {
      return `支出-${data.expenseCategory.name} <font color=red>(-${amount})</font>`;
    }
    return amount;
  },

  formatUserLevel(data: any, column: any, value: any) {
    if (isEmpty(userLevel)) {
      userLevel = getEnumMap(store.getters["enums/getEnumsByKey"]("UserType"));
    }
    return userLevel ? userLevel.get(value) : value;
  },

  formatBillRevenueCategory(data: any, column: any, value: any) {
    return data.revenueCategory ? data.revenueCategory.name : "";
  },

  formatBillExpenseCategory(data: any, column: any, value: any) {
    return data.expenseCategory ? data.expenseCategory.name : "";
  },

  formatBillBuilding(data: any, column: any, value: any) {
    return data.building ? data.building.code : "";
  },

  formatBillEmployee(data: any, column: any, value: any) {
    return data.employee ? data.employee.name : "";
  },

  formatBillCreatedUser(data: any, column: any, value: any) {
    return data.createdUser ? data.createdUser.name : "";
  },

  formatBillModifiedUser(data: any, column: any, value: any) {
    return data.modifiedUser ? data.modifiedUser.name : "";
  },

  formatBillPayType(data: any, column: any, value: any) {
    if (isEmpty(payType)) {
      payType = getEnumMap(store.getters["enums/getEnumsByKey"]("PayType"));
    }
    return payType ? payType.get(value) : value;
  },

  formatGender(data: any, column: any, value: any) {
    if (isEmpty(gender)) {
      gender = getEnumMap(store.getters["enums/getEnumsByKey"]("Gender"));
    }
    return gender ? gender.get(value) : value;
  },

  formatMessageType(data: any, column: any, value: any) {
    if (isEmpty(messageType)) {
      messageType = getEnumMap(
        store.getters["enums/getEnumsByKey"]("MessageType")
      );
    }
    return messageType ? messageType.get(value) : value;
  },

  formatOperationType(data: any) {
    if (isEmpty(operationType)) {
      operationType = getEnumMap(
        store.getters["enums/getEnumsByKey"]("OperationType")
      );
    }
    const action = data.operationType || "";
    return operationType ? operationType.get(action) || "--" : action;
  },

  formatPhone(data: any, column: any, value: any) {
    if (isEmptyOrWhiteSpace(value)) {
      return "";
    }
    // const len = value.length;
    // if (len > 6) {
    //   const phone = value.substring(0, 3) + "***" + value.substring(len - 3);
    //   if (store.getters["user/user"].userType === "ADMIN") {
    //     return `<div>
    //       <span id="phone-s-${data.id}" style="display:inline;">${phone}</span>
    //       <span id="phone-a-${data.id}" style="display:none;">${value}</span>
    //       <i class="el-icon-view" title="查看" style="padding-left:2px;cursor:pointer;" 
    //       onclick="document.getElementById('phone-s-${data.id}').style.display='none';
    //       document.getElementById('phone-a-${data.id}').style.display='inline';
    //       this.style.display='none'">
    //       </i>
    //     </div>`;
    //   }
    //   return phone;
    // }
    return value;
  },

  formatEmail(data: any, column: any, value: any) {
    if (isEmptyOrWhiteSpace(value)) {
      return "";
    }
    // if (value.indexOf("@") <= 0) {
    //   return value;
    // }
    // const values = value.split("@");
    // if (values.length !== 2) {
    //   return value;
    // }
    // const email = values[0].substring(0, 1) + "***@" + values[1];
    // if (store.getters["user/user"].userType === "ADMIN") {
    //   return `<div>
    //     <span id="email-s-${data.id}" style="display:inline;">${email}</span>
    //     <span id="email-a-${data.id}" style="display:none;">${value}</span>
    //     <i class="el-icon-view" title="查看" style="padding-left:2px;cursor:pointer;" 
    //     onclick="document.getElementById('email-s-${data.id}').style.display='none';
    //     document.getElementById('email-a-${data.id}').style.display='inline';
    //     this.style.display='none'">
    //     </i>
    //   </div>`;
    // }
    return value;
  },

  formatUserInfo(user: any) {
    return user ? user.name : "--";
  },
  
  formatUserStatus(data: any) {
    return data.disabled
      ? "<font color='#F56C6C'>停用</font>"
      : "<font color='#67C23A'>正常</font>";
  }
};

export function mapFormatters(names: Array<string>) {
  if (!names || !names.length) {
    return {};
  }
  const funcs: {
    [key: string]: (data: any, column: any, value: any) => string;
  } = {};
  names.forEach(name => {
    funcs[name] =
      map[name] ||
      function(data: any, column: any, value: any) {
        return value;
      };
  });
  return funcs;
}

export default map;
